import type { ForcedDataOption } from "@/constants/forced-data-options.constant";
import { forcedDataOptionsStruct } from "@/constants/forced-data-options.constant";
import { is } from "superstruct";

export function parseForcedDataOption(
  value: unknown,
): ForcedDataOption | undefined {
  return is(value, forcedDataOptionsStruct) ? value : undefined;
}
